import {EstabelecimentoSisbi} from './estabelecimento-sisbi';
import {PessoaFisicaSisbi} from './pessoa-fisica-sisbi';
import {PessoaSisbi} from './pessoa-sisbi';

export class ProdutoSisbi {
    idProdutoSisbi: number;
    nmVenda: string;
    csComercio: string;
    csSisbi: string;
    nrRegistro: string;
    finalidadeProduto: FinalidadeProduto;
    dsProcessoFabricacao: string;
    dsJustificativaSisbi: string;
    // arquivoProdutoIrregular: string;
    estabelecimentoSisbi: EstabelecimentoSisbi;
    produtoSif: ProdutoSif;
    csProduto: string;
    // finalidadeProduto: string;
    csSuspensaoSisbi: string;
    csAtivoSisbi: string;
    idDiretrizProdSisbiPadro: number;
    pessoaFisicaSisbi: PessoaSisbi;
    seloSisbi: string;
    idArquivoRotulo: number;

    get isAtivo(): boolean {
        return this.csAtivoSisbi === 'AT';
    }

    get nmAtivo(): string {
        switch (this.csAtivoSisbi) {
            case 'AT':
                return 'Ativo';
            case 'IP':
                return 'Inativação Parcial';
            case 'IN':
                return 'Inativo';
            case 'IT':
                return 'Inativação Total';
        }
    }

    get nmCsComercio(): string {
        switch (this.csComercio) {
            case 'M':
                return 'MUNICIPAL';
            case 'E':
                return 'ESTADUAL';
            case 'C':
                return 'CONSÓRCIO';
            case 'N':
                return 'Nacional';
        }
    }


    /**
     * Converte um objeto json em instancias da classe
     */
    static fromJson(jsonData: any): ProdutoSisbi {
        if (jsonData.pessoaFisicaSisbi != null) {
            jsonData.pessoaFisicaSisbi = PessoaFisicaSisbi.fromJson(jsonData.pessoaFisicaSisbi);
        }
        if (jsonData.estabelecimentoSisbi != null) {
            jsonData.estabelecimentoSisbi = EstabelecimentoSisbi.fromJson(jsonData.estabelecimentoSisbi);
        }
        if (jsonData.finalidadeProduto != null) {
            jsonData.finalidadeProduto = FinalidadeProduto.fromJson(jsonData.finalidadeProduto);
        }
        if (jsonData.produtoSif != null) {
            jsonData.produtoSif = ProdutoSif.fromJson(jsonData.produtoSif);
        }
        return Object.assign(new ProdutoSisbi(), jsonData);
    }

}

export class FinalidadeProduto {
    dsFinalidadeProduto: string;
    idFinalidadeProduto: number;

    static fromJson(jsonData: any): FinalidadeProduto {
        return Object.assign(new FinalidadeProduto(), jsonData);
    }
}

export class ProdutoSif {
    idProdutoPadronizado: number;
    nmProdutoPadronizado: string;
    idTipoAreaEstab: number;
    nmTipoAreaEstab: string;
    idCategoriaProduto: number;
    nmCategoriaProduto: string;
    idProcTecnProduto: number;
    nmProcTecnProduto: string;
    idCaracProduto: number;
    nmCaracProduto: string;
    idFormaConsProduto: number;
    nmFormaConsProduto: string;
    idEspecie: number;
    nmEspecie: string;
    idUnidadeMedida: number;
    dsUnidadeMedida: string;
    sgUnidadeMedida: string;
    idIngredienteProduto: number;
    nmIngredienteProduto: string;

    // Ativo stRegulamentado;

    static fromJson(jsonData: any): ProdutoSif {
        return Object.assign(new ProdutoSif(), jsonData);
    }
}




